var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		[_vm.$style['md-switch-container']]: true,
		[_vm.$style['md-switch-container--checked']]: _vm.value,
		[_vm.$style['md-switch-container--disabled']]: _vm.disabled
	},on:{"click":_vm.toggleSwitch}},[_c('div',{class:_vm.$style['md-switch-track']}),_c('div',{class:_vm.$style['md-switch-handle']})])
}
var staticRenderFns = []

export { render, staticRenderFns }